<template>
    <div class="breadcrumps">
        <template v-for="(page, index) in pages" :key="index">
            <span v-if="index === pages.length - 1" class="is-active">
                {{ page.text }}
            </span>
            <template v-if="index < pages.length - 1">
                <span>
                    <NuxtLink :to="domain + page.href">{{ page.text }}</NuxtLink>
                </span>
                <span class="breadcrumps__separator">&gt;</span>
            </template>
        </template>
    </div>
</template>

<script setup lang="ts">
interface IPage {
    href?: string;
    text: string;
}
interface IBreadCrumbs {
    pages: IPage[];
}

const domain = useRuntimeConfig().public.SITE_URL;

defineProps<IBreadCrumbs>();
</script>

<style scoped lang="postcss">
.breadcrumps {
    @apply text-primary text-sm;
    &__separator {
        @apply inline-block px-1.5;
    }
    span.is-active {
        @apply underline;
    }
}
</style>
